import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { IndividualResults } from './components';
import useSurvey from './useSurvey';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const SurveyResultsResponse = props => {
  const { className, ...rest } = props;
  const survey = useSurvey();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <IndividualResults survey={survey} showNav={true} />
      </div>
    </div>
  );
};

export default SurveyResultsResponse;
